<template>
  <div style="" class="father">
    <wty-shopinfo :who="'service'"></wty-shopinfo>
  </div>
</template>
<script>
import wtyShopinfo from '@/components/wty-shopinfo.vue'
export default {
  name: "sinformation",
  components: {
    wtyShopinfo
  },
  methods: {
  }
}
</script>
<style scoped>
.father {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  border-radius: 5px !important;
  overflow: hidden;
}
</style>